export default "__VITE_ASSET__BCW9byHp__"